import { render, staticRenderFns } from "./SearcherPurchaseOriginFlgs.vue?vue&type=template&id=374197c3&"
import script from "./SearcherPurchaseOriginFlgs.vue?vue&type=script&lang=js&"
export * from "./SearcherPurchaseOriginFlgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
